import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css';


import React from 'react';
import Main from './pages/Main';
import './App.css';

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
